
import React, { Fragment, useRef, useState} from "react";
import AspectRatioShell from "../AspectRatioShell";
import { useImageInputContext } from "../../ImageInputContext";
import { smallImageInputUIConditionsMet } from "../ImageEditor/utils/smallImageInputUIConditionsMet";
import { icons, colors, SANS_0, SANS_2, SANS_3, SANS_3_4, ModalConfirm } from "oolib";

import { StyledCautionMsg } from "./styled";
import { _Locale as localize } from "@/components/locale/Locale";

import { FileUploadWrapper } from "oolib/dist/components/FileUploadWrapper"; // todo : update imports
import { genIcon } from "oolib/dist/v2/components/Dropdowns/utils/genIcon" // todo: need global genIcon

const { ImageSquare } = icons;
const { greyColor100 } = colors;

const Placeholder = ({aspectRatio: aspectRatioProp}) => {
  const {
    aspectRatio : aspectRatioFromContext,
    containerShape,
    uploadProgress,
    isLoading,
    dropzoneLabel,
    dropzoneSublabel,
    stretchToFullHeight,
    multiple,
    showOptionalLabelInDropzone,
    isRequired,
    showImageUploadCaution,
    uploadArgs,
    showModal,
    setShowModal
  } = useImageInputContext();

  /** cuz in inlineimageinput we define an explicit aspect ratio for the placeholder only. since the image doesnt need an aspect ratio container */
  const aspectRatio = aspectRatioProp || aspectRatioFromContext

  const styledPlaceholderWrapperRef = useRef(null);
  const [smallPlaceholderUI, setSmallPlaceholderUI] = useState(false)

  const decideUIStyle = () => {
    // This function makes sure that we have received actual width and height from AspectRatioShell comp, 
    // onShellPrepared is the function that is getting called inside AspectRatioShell Comp to determine height and width of shell based on wrapper-Width and stretchToFullHeight prop inside <AspectRatioShell/> Comp
    const { width } = styledPlaceholderWrapperRef.current.getBoundingClientRect();
    if(smallImageInputUIConditionsMet({width, containerShape})){
      setSmallPlaceholderUI(true)
    }else{
      setSmallPlaceholderUI(false)
    }
  }


  /**
   * placeholder is shown only if:
   * - no value is passed to the SingleImageInput
   * - OR value is there, but the current image is being replaced
   * In all other cases, i.e value exists and THIS image is not currently being replaced,
   * then that image is rendered instead of placeholder
   *
   */

  // const [dragOverActive, setDragOverActive] = useState(false)
  const { handleUpload, onChange, value, id} = useImageInputContext()
 
  const inputRef = useRef(null);

  const handleOnConfirm = () => {
    localStorage.setItem("PreUploadImageCautionAcknowleged","true")
    handleUpload({...uploadArgs})
    setShowModal(false);
  }

  return (
    <>
      <AspectRatioShell
        {...{
          aspectRatio,
          containerShape,
          stretchToFullHeight,
          onShellPrepared: decideUIStyle,
        }}
      >
        <FileUploadWrapper
          styledPlaceholderWrapperRef={styledPlaceholderWrapperRef}
          uploadProgress={uploadProgress}
          isLoading={isLoading}
          containerShape={containerShape}
          multiple={multiple}
          smallPlaceholderUI={smallPlaceholderUI}
          mediaType={"image"}
          handleUpload={handleUpload}
          onChange={onChange}
          value={value}
          id={id}
          inputRef={inputRef}
        >
          {smallPlaceholderUI ? (
            <Fragment>
              <ImageSquare size={16} color={greyColor100} />
              <SANS_0 semibold>{dropzoneLabel}</SANS_0>
              {showOptionalLabelInDropzone && isRequired === false && (
                <SANS_0>{"(optional)"}</SANS_0>
              )}
            </Fragment>
          ) : (
            <Fragment>
              <ImageSquare size={30} color={greyColor100} />
              <SANS_2 semibold>{`${localize(dropzoneLabel)} ${
                showOptionalLabelInDropzone && isRequired === false
                  ? "(optional)"
                  : ""
              }`}</SANS_2>
              <SANS_2>{dropzoneSublabel}</SANS_2>
            </Fragment>
          )}
          {showImageUploadCaution.enable ? (
            <StyledCautionMsg>
              <div style={{ flex: 0 }}>{genIcon({ icon: "Info" })}</div>
              <SANS_3 style={{ textAlign: "left" }}>
                {showImageUploadCaution.subTitle}
              </SANS_3>
            </StyledCautionMsg>
          ) : null}
        </FileUploadWrapper>
      </AspectRatioShell>

      {showModal ? (
        <ModalConfirm
          {...showImageUploadCaution}
          onClose={() => setShowModal(false)}
          onConfirm={handleOnConfirm}
        />
      ) : null}
    </>
  );
};

export default Placeholder;
